import { useTheme } from "../../../../context/useThemeContext";
import { hexToRGBA } from "../../../../utility/hexToRGB";
import useDataStore from "../../../../stores/dataStore";

function NumSelectedInFolder(props: {
    id?: string;
    numOpenedNotesInFolder: number;
}) {
    const { theme } = useTheme();

    // Store
    const folderColor = useDataStore((state) =>
        props.id
            ? theme.accentColors[state.data.folders[props.id]?.color]
            : theme.fontColor[100]
    );

    return (
        <>
            {props.numOpenedNotesInFolder > 0 && (
                <div
                    className="h-[20px] w-[20px] flex justify-center items-center rounded"
                    style={{
                        backgroundColor: hexToRGBA(folderColor, 0.25),
                    }}
                >
                    <p className="text-xs">{props.numOpenedNotesInFolder}</p>
                </div>
            )}
        </>
    );
}

export default NumSelectedInFolder;
